export default {"src":"/_next/static/media/icon-thin-plus.26bcbfc4.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};